export enum ChargeDiscount {
    Discount = 0,
    Charge = 1
}

export type SaleInvoiceModifier = {
    id: number;
    name: string;
    amount: number;
    isPercentage: boolean;
    modifierType: ChargeDiscount;
}

export const DefaultSaleInvoiceModifier: SaleInvoiceModifier = {
    id: 0,
    name: '',
    amount: 0,
    isPercentage: false,
    modifierType: ChargeDiscount.Discount
}